export const SNAPSHOT_PANEL_WIDTH_PX = 420

export const EXPANDED_CHART_PANEL_WIDTH_PX = 760

function clampWidthToPanelHeight(
    fitted: number,
    minWidth: number,
    panelHeight?: number,
    heightRatio = 0.75
): number {
    if (!panelHeight || panelHeight <= 0) return fitted
    const heightCap = panelHeight * heightRatio
    return Math.max(Math.min(minWidth, heightCap), Math.min(fitted, heightCap))
}

/** SVG width that fits inside the snapshot panel with toolbar/legend margins. */
export function fitChartWidth(
    compact: boolean | undefined,
    panelWidth: number | undefined,
    defaultWidth: number,
    minWidth = 96,
    panelHeight?: number,
    heightRatio = 0.75
): number {
    if (!panelWidth) return defaultWidth
    const edgePad = compact ? 36 : 56
    const fitted = Math.max(minWidth, panelWidth - edgePad)
    return clampWidthToPanelHeight(fitted, minWidth, panelHeight, heightRatio)
}

/** Table mean charts split width between labels and bars; use tighter padding in expand view. */
export function fitTableMeanChartWidth(
    compact: boolean | undefined,
    panelWidth: number | undefined,
    defaultWidth: number
): number {
    if (!panelWidth) return defaultWidth
    const isExpanded = !compact && panelWidth >= EXPANDED_CHART_PANEL_WIDTH_PX - 80
    const edgePad = compact ? 28 : isExpanded ? 32 : 4
    const minWidth = compact ? 160 : isExpanded ? 520 : 200
    return Math.max(minWidth, panelWidth - edgePad)
}

/** Scale chart height smoothly as the panel grows wider. */
export function fitChartHeight(
    compact: boolean | undefined,
    chartWidth: number,
    compactHeight: number,
    minHeight: number,
    maxHeight: number
): number {
    if (compact) return compactHeight
    const narrowW = 244
    const wideW = 884
    const t = Math.min(1, Math.max(0, (chartWidth - narrowW) / (wideW - narrowW)))
    return Math.round(minHeight + t * (maxHeight - minHeight))
}

export function resolveChartDefaultWidth(
    compact: boolean | undefined,
    panelWidth: number | undefined,
    compactDefault: number,
    panelDefault: number,
    expandedDefault: number
): number {
    if (compact) return compactDefault
    if ((panelWidth ?? 0) >= EXPANDED_CHART_PANEL_WIDTH_PX - 80) return expandedDefault
    return panelDefault
}
